<template>
  <div>
    <el-tooltip class="item"
                effect="dark"
                :disabled="valid"
                content="Complete a lo menos los datos generales para guardar su configuración"
                placement="bottom">
      <el-input
        placeholder="Ingrese Alias de Configuración"
        size="mini"
        :disabled="!valid"
        v-model="alias"
        maxlength="40"
        v-loading="loadSave"
        class="mini-loader"
        show-word-limit>
        <el-button slot="append"
                   :disabled="!valid"
                   class="default btn-append"
                   @click="saveConfig">
          GUARDAR *
        </el-button>
      </el-input>
    </el-tooltip>
    <p class="description">
      * Se guardaran los DATOS GENERALES y SECTORES ya ingresados.
    </p>
  </div>
</template>

<script>
import { apiRequest } from '../../../../backend/vue-axios/axios';

export default {
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    valid: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  name: 'ConfigSave',
  data() {
    return {
      alias: '',
      loadSave: false,
    };
  },
  methods: {
    saveConfig() {
      if (this.alias !== null && this.alias.length > 0) {
        this.loadSave = true;
        apiRequest(
          {
            module: 'planning',
            service: 'create_advanced_config_planning',
            params: { alias: this.alias, config: JSON.stringify(this.data) },
          },
        ).then(() => {
          this.loadSave = false;
          this.$notify({
            title: 'OK',
            message: 'Configuración creada',
            type: 'success',
          });
        }).catch(() => {
          this.loadSave = false;
          this.$notify({
            type: 'error',
            title: 'Error',
            message: 'Problemas al guardar la configuración',
          });
        });
      } else {
        this.$notify({
          type: 'warning',
          title: 'Ingrese un alias para continuar',
        });
      }
    },
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
  .btn-append {
    padding: 8px 20px;
    border-radius: inherit;
    margin-right: -21px !important;
  }
  .description {
     color: $fb-grey-light-50;
     margin: 4px 0 0;
  }
</style>
